import { useState, useEffect } from "react"
import { doc, getDoc, collection, getDocs } from "firebase/firestore"
import { db } from "../services/firebase"
import { useAuth } from "../context/AuthContext"
import { calcularEstadoCliente, COLORES_ESTADO } from "../utils/estadoCliente"
import { obtenerMedallasCliente } from "../utils/destinoUtils"
import "./Dashboard.css"

const TABLA_CANJE = [
  { puntos: 50,  descuento: 10  },
  { puntos: 100, descuento: 25  },
  { puntos: 350, descuento: 100 },
]

const CONQUISTAS = [
  {
    region: "Brasil",
    emoji: "🇧🇷",
    destinos: [
      { nombre: "Florianopolis",      emoji: "🏖️" },
      { nombre: "Camboriu",           emoji: "🎡" },
      { nombre: "Rio de Janeiro",     emoji: "🗿"  },
      { nombre: "Buzios",             emoji: "⛵"  },
      { nombre: "Arraial do Cabo",    emoji: "🤿"  },
      { nombre: "Arraial D'Ajuda",    emoji: "🌿"  },
      { nombre: "Cabo Frio",          emoji: "🌊"  },
      { nombre: "Barra de Tijuca",    emoji: "🏙️" },
      { nombre: "Porto de Galinhas",  emoji: "🐠"  },
      { nombre: "Porto Seguro",       emoji: "⛺"  },
      { nombre: "Bombas y Bombinhas", emoji: "🌴"  },
      { nombre: "Maceio",             emoji: "🌅"  },
      { nombre: "Maragogi",           emoji: "💎"  },
      { nombre: "Natal",              emoji: "🌴"  },
      { nombre: "Pipa",               emoji: "🪁"  },
    ]
  },
  {
    region: "Caribe",
    emoji: "🌴",
    destinos: [
      { nombre: "Punta Cana",         emoji: "🌺"  },
      { nombre: "Bayahibe",           emoji: "🐚"  },
      { nombre: "Puerto Plata",       emoji: "🏄"  },
      { nombre: "Cancun",             emoji: "🐚"  },
      { nombre: "Playa del Carmen",   emoji: "🎭"  },
      { nombre: "Cartagena",          emoji: "🏰"  },
      { nombre: "Panama",             emoji: "🛳️" },
    ]
  },
]

function CuentaRegresiva({ fechaSalida }) {
  const [tiempo, setTiempo] = useState({})
  useEffect(() => {
    function calcular() {
      const diff = new Date(fechaSalida) - new Date()
      if (diff <= 0) return setTiempo({ dias: 0, horas: 0, minutos: 0 })
      setTiempo({
        dias:    Math.floor(diff / (1000 * 60 * 60 * 24)),
        horas:   Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutos: Math.floor((diff / (1000 * 60)) % 60),
      })
    }
    calcular()
    const i = setInterval(calcular, 60000)
    return () => clearInterval(i)
  }, [fechaSalida])

  return (
    <div className="cuenta-regresiva">
      {[{ n: tiempo.dias, u: "dias" }, { n: tiempo.horas, u: "horas" }, { n: tiempo.minutos, u: "minutos" }].map(({ n, u }) => (
        <div className="cuenta-regresiva__bloque" key={u}>
          <span className="cuenta-regresiva__numero">{n ?? "—"}</span>
          <span className="cuenta-regresiva__unidad">{u}</span>
        </div>
      ))}
    </div>
  )
}

function BadgeEstado({ estado, label }) {
  const colores = COLORES_ESTADO[estado] || COLORES_ESTADO.sin_viaje
  return (
    <span style={{ display: "inline-block", padding: "4px 12px", borderRadius: "20px", fontSize: "0.8rem", fontWeight: 700, background: colores.bg, color: colores.text, border: "1px solid " + colores.text + "40" }}>
      {label}
    </span>
  )
}

function ViajeCard({ v }) {
  const [expandido, setExpandido] = useState(false)
  const tieneDetalle = v.hotel1 || v.hotel2 || v.incluye || v.asistencia

  return (
    <div className="viaje-card" style={{ flexDirection: "column", alignItems: "stretch", gap: 0 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div className="viaje-card__destino">{v.destino}</div>
          <div className="viaje-card__meta">
            {v.aerolinea && <span>{v.aerolinea}</span>}
            {v.fecha_salida && <span> · {new Date(v.fecha_salida).toLocaleDateString("es-AR")}</span>}
            {v.fecha_regreso && <span> → {new Date(v.fecha_regreso).toLocaleDateString("es-AR")}</span>}
            {v.noches > 0 && <span> · {v.noches} noches</span>}
            {v.pax > 0 && <span> · {v.pax} pax</span>}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span className={"viaje-card__badge badge--" + v.estado}>{v.estado}</span>
          {tieneDetalle && (
            <button
              onClick={() => setExpandido(!expandido)}
              style={{ background: "none", border: "1px solid #e8e4dc", borderRadius: "6px", padding: "4px 8px", fontSize: "0.75rem", color: "#9ca3af", cursor: "pointer" }}
            >
              {expandido ? "Ocultar" : "Ver mas"}
            </button>
          )}
        </div>
      </div>

      {expandido && tieneDetalle && (
        <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #f0ede6", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
          {v.hotel1 && (
            <div>
              <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.5px" }}>Hotel 1</div>
              <div style={{ fontSize: "0.875rem", color: "#374151" }}>{v.hotel1}</div>
            </div>
          )}
          {v.hotel2 && (
            <div>
              <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.5px" }}>Hotel 2</div>
              <div style={{ fontSize: "0.875rem", color: "#374151" }}>{v.hotel2}</div>
            </div>
          )}
          {v.incluye && (
            <div style={{ gridColumn: "1 / -1" }}>
              <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.5px" }}>Incluye</div>
              <div style={{ fontSize: "0.875rem", color: "#374151" }}>{v.incluye}</div>
            </div>
          )}
          {v.asistencia && (
            <div>
              <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.5px" }}>Asistencia</div>
              <div style={{ fontSize: "0.875rem", color: v.asistencia === "Si" ? "#10b981" : "#6b7280" }}>{v.asistencia}</div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default function Dashboard() {
  const { user, userData } = useAuth()
  const [tabActiva, setTabActiva]     = useState("perfil")
  const [clienteData, setClienteData] = useState(null)
  const [viajes, setViajes]           = useState([])
  const [vouchers, setVouchers]       = useState([])
  const [loading, setLoading]         = useState(true)
  const [error, setError]             = useState(null)

  const tabs = [
    { id: "perfil",      label: "Perfil"      },
    { id: "viajes",      label: "Viajes"      },
    { id: "maletin",     label: "Maletin"     },
    { id: "fidelidad",   label: "Fidelidad"   },
    { id: "conquistas",  label: "Conquistas"  },
    { id: "ayuda",       label: "Ayuda"       },
  ]

useEffect(() => {
  async function cargarDatos() {
    if (!userData?.id_cliente_asociado) { setLoading(false); return }
      const id = userData.id_cliente_asociado.toString()
      try {
        const [clienteSnap, viajesSnap, vouchersSnap] = await Promise.all([
          getDoc(doc(db, "usuarios_sheets", id)),
          getDocs(collection(db, "usuarios_sheets", id, "viajes")),
          getDocs(collection(db, "usuarios_sheets", id, "vouchers")),
        ])
        if (clienteSnap.exists()) setClienteData(clienteSnap.data())
        setViajes(viajesSnap.docs.map(d => ({ id: d.id, ...d.data() })))
        setVouchers(vouchersSnap.docs.map(d => ({ id: d.id, ...d.data() })))
      } catch (e) {
        console.error(e)
        setError("Hubo un problema al cargar tu panel. Intentá recargar la página.")
      } finally {
        setLoading(false)
      }
    }
    cargarDatos()
  }, [userData])

  const puntosAporte    = clienteData?.puntos_aporte     || 0
  const puntosFeedback  = clienteData?.puntos_feedback   || 0
  const puntosReferidos = clienteData?.puntos_referidos  || 0
  const puntosCompraRef = clienteData?.puntos_compra_ref || 0
  const puntosCumple    = clienteData?.puntos_cumpleanos || 0
  const puntosUsados    = clienteData?.puntos_usados     || 0
  const totalPuntos     = puntosAporte + puntosFeedback + puntosReferidos + puntosCompraRef + puntosCumple - puntosUsados
  const mejorCanje      = [...TABLA_CANJE].reverse().find(t => totalPuntos >= t.puntos)
  const estadoActual    = calcularEstadoCliente(viajes)
  const medallasCliente = obtenerMedallasCliente(viajes)

  const hoy          = new Date()
  const proximoViaje = viajes
    .filter(v => v.estado !== "cancelado" && new Date(v.fecha_salida) > hoy)
    .sort((a, b) => new Date(a.fecha_salida) - new Date(b.fecha_salida))[0]

  const nombre = userData?.nombre || user?.email?.split("@")[0] || "viajero"

  if (loading) return <div style={{ textAlign: "center", padding: "80px 20px", color: "#9ca3af" }}>Cargando tu panel...</div>

  if (error) return (
    <div style={{ textAlign: "center", padding: "80px 20px" }}>
      <div style={{ fontSize: "2rem", marginBottom: "12px" }}>⚠️</div>
      <div style={{ color: "#ef4444", fontWeight: 600, marginBottom: "16px" }}>{error}</div>
      <button
        onClick={() => window.location.reload()}
        style={{ padding: "10px 24px", background: "#0f2340", border: "none", borderRadius: "8px", color: "white", fontWeight: 700, cursor: "pointer" }}
      >
        Recargar
      </button>
    </div>
  )

  return (
    <div className="dashboard">
      <div className="container">

        {/* HERO */}
        <div className="dashboard__hero fade-in">
          <div>
            <div className="dashboard__saludo">Hola, {nombre}</div>
            <div className="dashboard__subsaludo" style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
              <span>Bienvenido a tu panel de viajes</span>
              <BadgeEstado {...estadoActual} />
            </div>
          </div>
          <div className="dashboard__puntos-card">
            <div className="dashboard__puntos-icono">⭐</div>
            <div>
              <div className="dashboard__puntos-label">Puntos totales</div>
              <div className="dashboard__puntos-numero">{totalPuntos}</div>
              {mejorCanje && <div style={{ fontSize: "0.75rem", color: "#c9a84c", marginTop: "2px" }}>Podes canjear -{mejorCanje.descuento} USD</div>}
            </div>
          </div>
        </div>

        {/* TABS */}
        <nav className="dashboard__tabs-nav">
          {tabs.map(t => (
            <button key={t.id} className={"dashboard__tab-btn" + (tabActiva === t.id ? " active" : "")} onClick={() => setTabActiva(t.id)}>
              {t.label}
            </button>
          ))}
        </nav>

        {/* PERFIL */}
        <div className={"dashboard__tab-pane" + (tabActiva === "perfil" ? " active" : "")}>
          <div className="dash-card">
            <div className="dash-card__titulo">Mis datos</div>
            <div className="perfil__grid">
              {[
                { label: "Nombre",     valor: userData?.nombre        },
                { label: "Apellido",   valor: userData?.apellido      },
                { label: "Email",      valor: user?.email             },
                { label: "Telefono",   valor: clienteData?.telefono   },
                { label: "Ciudad",     valor: clienteData?.ciudad     },
                { label: "Nacimiento", valor: clienteData?.nacimiento },
              ].map(({ label, valor }) => (
                <div className="perfil__campo" key={label}>
                  <span className="perfil__label">{label}</span>
                  <span className="perfil__valor">{valor || "—"}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* VIAJES */}
        <div className={"dashboard__tab-pane" + (tabActiva === "viajes" ? " active" : "")}>

          {estadoActual.estado === "en_viaje" && (
            <div style={{ background: "linear-gradient(135deg, #0a2a1a, #0f3a24)", border: "1px solid #10b98140", borderRadius: "14px", padding: "24px", marginBottom: "20px", textAlign: "center" }}>
              <div style={{ fontSize: "2rem", marginBottom: "8px" }}>🌍</div>
              <div style={{ fontWeight: 800, color: "#10b981", fontSize: "1.1rem", marginBottom: "4px" }}>Estas de viaje!</div>
              <div style={{ color: "#9ca3af", fontSize: "0.875rem" }}>
                {estadoActual.viaje?.destino} · Regreso el {estadoActual.viaje?.fecha_regreso ? new Date(estadoActual.viaje.fecha_regreso).toLocaleDateString("es-AR") : "—"}
              </div>
            </div>
          )}

          {estadoActual.estado === "checkin" && (
            <div style={{ background: "linear-gradient(135deg, #3a2a0a, #4a3a0a)", border: "1px solid #f59e0b40", borderRadius: "14px", padding: "24px", marginBottom: "20px", textAlign: "center" }}>
              <div style={{ fontSize: "2rem", marginBottom: "8px" }}>🎒</div>
              <div style={{ fontWeight: 800, color: "#f59e0b", fontSize: "1.1rem", marginBottom: "4px" }}>Es hora del check-in!</div>
              <div style={{ color: "#9ca3af", fontSize: "0.875rem" }}>Tu vuelo a {estadoActual.viaje?.destino} sale muy pronto</div>
            </div>
          )}

          {proximoViaje && estadoActual.estado === "pendiente" && (
            <div className="proximo-viaje">
              <div className="proximo-viaje__label">Proximo viaje</div>
              <div className="proximo-viaje__destino">{proximoViaje.destino}</div>
              <div className="proximo-viaje__fecha">
                {new Date(proximoViaje.fecha_salida).toLocaleDateString("es-AR", { weekday: "long", year: "numeric", month: "long", day: "numeric" })}
              </div>
              <CuentaRegresiva fechaSalida={proximoViaje.fecha_salida} />
            </div>
          )}

          <div className="dash-card">
            <div className="dash-card__titulo">Historial de viajes</div>
            {viajes.length === 0 ? (
              <div className="empty-state">
                <div className="empty-state__icono">✈️</div>
                <div className="empty-state__texto">Todavia no tenes viajes registrados.</div>
              </div>
            ) : (
              viajes
                .sort((a, b) => new Date(b.fecha_salida) - new Date(a.fecha_salida))
                .map(v => <ViajeCard key={v.id} v={v} />)
            )}
          </div>
        </div>

        {/* MALETIN */}
        <div className={"dashboard__tab-pane" + (tabActiva === "maletin" ? " active" : "")}>
          <div className="dash-card">
            <div className="dash-card__titulo">Mis documentos</div>
            {vouchers.length === 0 ? (
              <div className="empty-state">
                <div className="empty-state__icono">📄</div>
                <div className="empty-state__texto">No hay documentos disponibles por el momento.</div>
              </div>
            ) : (
              vouchers.map(v => (
                <div className="voucher-item" key={v.id}>
                  <div>
                    <div className="voucher-item__titulo">{v.titulo}</div>
                    <div className="voucher-item__meta">{v.tipo} · Valido hasta {v.valido_hasta}</div>
                  </div>
                  <a href={v.url_storage} target="_blank" rel="noreferrer" className="voucher-item__btn">Descargar</a>
                </div>
              ))
            )}
          </div>
        </div>

        {/* FIDELIDAD */}
        <div className={"dashboard__tab-pane" + (tabActiva === "fidelidad" ? " active" : "")}>
          <div className="dash-card">
            <div className="dash-card__titulo">Mis puntos</div>
            <div className="puntos-hero">
              <div className="puntos-hero__icono">⭐</div>
              <div>
                <div className="puntos-hero__numero">{totalPuntos}</div>
                <div className="puntos-hero__label">Puntos disponibles</div>
              </div>
            </div>

            <div style={{ marginTop: "20px", borderTop: "1px solid #e8e4dc", paddingTop: "16px" }}>
              <div style={{ fontSize: "0.8rem", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Desglose</div>
              {[
                { label: "Por viajes",          valor: puntosAporte,    color: "#0f2340"  },
                { label: "Por cumpleanos",       valor: puntosCumple,    color: "#c9a84c"  },
                { label: "Por feedback",         valor: puntosFeedback,  color: "#6366f1"  },
                { label: "Por referidos",        valor: puntosReferidos, color: "#10b981"  },
                { label: "Por compra referidos", valor: puntosCompraRef, color: "#06b6d4"  },
                { label: "Puntos canjeados",     valor: puntosUsados,    color: "#ef4444", resta: true },
              ].map(item => (
                <div key={item.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid #f0ede6" }}>
                  <span style={{ fontSize: "0.875rem", color: "#6b7280" }}>{item.label}</span>
                  <span style={{ fontWeight: 700, color: item.color, fontSize: "0.875rem" }}>{item.resta ? "-" : "+"}{item.valor} pts</span>
                </div>
              ))}
            </div>

            <div style={{ marginTop: "20px", borderTop: "1px solid #e8e4dc", paddingTop: "16px" }}>
              <div style={{ fontSize: "0.8rem", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Tabla de canje</div>
              {TABLA_CANJE.map(t => {
                const disponible = totalPuntos >= t.puntos
                return (
                  <div key={t.puntos} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", borderRadius: "8px", marginBottom: "6px", background: disponible ? "#fdf8ee" : "#f8f6f1", border: "1px solid " + (disponible ? "#c9a84c" : "#e8e4dc"), opacity: disponible ? 1 : 0.5 }}>
                    <span style={{ fontSize: "0.875rem", color: "#6b7280" }}>{t.puntos} puntos</span>
                    <span style={{ fontWeight: 700, color: disponible ? "#c9a84c" : "#9ca3af" }}>{disponible ? "✓" : "✗"} -{t.descuento} USD</span>
                  </div>
                )
              })}
              <div style={{ fontSize: "0.8rem", color: "#9ca3af", marginTop: "10px", lineHeight: 1.5 }}>
                Los puntos se aplican como descuento a partir del segundo viaje. Habla con tu asesor para usarlos.
              </div>
            </div>
          </div>

          {/* REFERIDOS */}
            <div className="dash-card">
              <div className="dash-card__titulo">Programa de referidos</div>

              <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "16px", background: "#f0fdf4", borderRadius: "12px", border: "1px solid #10b98130", marginBottom: "20px" }}>
                <span style={{ fontSize: "2rem" }}>🤝</span>
                <div>
                  <div style={{ fontWeight: 700, color: "#0f2340", fontSize: "1rem", marginBottom: "2px" }}>
                    Llevá un amigo y ganá puntos
                  </div>
                  <div style={{ fontSize: "0.875rem", color: "#6b7280", lineHeight: 1.5 }}>
                    Cada amigo que referís y se registra te suma <strong>30 puntos</strong>. Si además viaja con Sergio, ganás <strong>50 puntos más</strong>. Podés referir hasta 5 personas.
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "20px" }}>
                {[
                  { label: "Por cada amigo registrado",    puntos: 30, icono: "👤" },
                  { label: "Por cada amigo que viaja",     puntos: 50, icono: "✈️" },
                  { label: "Máximo de personas referidas", puntos: 5,  icono: "🔢", esCantidad: true },
                ].map(item => (
                  <div key={item.label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#f8f6f1", borderRadius: "8px", border: "1px solid #e8e4dc" }}>
                    <span style={{ fontSize: "0.875rem", color: "#6b7280" }}>{item.icono} {item.label}</span>
                    <span style={{ fontWeight: 700, color: "#0f2340", fontSize: "0.875rem" }}>
                      {item.esCantidad ? `${item.puntos} personas` : `+${item.puntos} pts`}
                    </span>
                  </div>
                ))}
              </div>

              <div style={{ background: "#fdf8ee", border: "1px solid #c9a84c40", borderRadius: "10px", padding: "14px 16px", marginBottom: "20px" }}>
                <div style={{ fontSize: "0.8rem", color: "#9ca3af", lineHeight: 1.6 }}>
                  💡 Para sumar tus puntos, pedile a tu amigo que mencione tu nombre cuando contacte a Sergio. Los puntos se acreditan una vez confirmado el registro o el viaje.
                </div>
              </div>

              <a
                href="https://wa.me/5491125603574?text=Hola Sergio! Quiero referir un amigo al programa de puntos"
                target="_blank"
                rel="noreferrer"
                style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "12px 20px", background: "#25d366", color: "white", borderRadius: "10px", fontWeight: 700, fontSize: "0.875rem", textDecoration: "none" }}
              >
                💬 Hablar con Sergio para referir
              </a>
            </div>
          </div>

          {/* CONQUISTAS */}
          <div className={"dashboard__tab-pane" + (tabActiva === "conquistas" ? " active" : "")}>
            <div className="dash-card">
            <div className="dash-card__titulo">Mapa de conquistas</div>
            <div style={{ fontSize: "0.875rem", color: "#9ca3af", marginBottom: "20px" }}>Los destinos que ya pisaste con Low Travel</div>

            {CONQUISTAS.map(region => {
              const visitadosRegion = region.destinos.filter(d => medallasCliente.has(d.nombre)).length
              return (
                <div key={region.region} style={{ marginBottom: "28px" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{ fontSize: "1.3rem" }}>{region.emoji}</span>
                      <span style={{ fontWeight: 700, color: "#0f2340", fontSize: "1rem" }}>{region.region}</span>
                    </div>
                    <span style={{ fontSize: "0.8rem", color: "#9ca3af", fontWeight: 600 }}>{visitadosRegion}/{region.destinos.length} visitados</span>
                  </div>
                  <div className="conquistas-grid">
                    {region.destinos.map(d => {
                      const visitado = medallasCliente.has(d.nombre)
                      return (
                        <div key={d.nombre} className={"conquista-item " + (visitado ? "visitado" : "pendiente")}>
                          <span className="conquista-item__emoji">{d.emoji}</span>
                          <span className="conquista-item__nombre">{d.nombre}</span>
                          {visitado && <span className="conquista-item__check">Visitado</span>}
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })}
            </div>
          
        </div>

        {/* AYUDA */}
        <div className={"dashboard__tab-pane" + (tabActiva === "ayuda" ? " active" : "")}>
          <div className="dash-card">
            <div className="dash-card__titulo">Necesitas ayuda?</div>
            <div className="ayuda-opciones">
              <a href="https://wa.me/5491125603574" target="_blank" rel="noreferrer" className="ayuda-btn">
                <span className="ayuda-btn__icono">💬</span>
                <div>
                  <div className="ayuda-btn__titulo">Escribir por WhatsApp</div>
                  <div className="ayuda-btn__sub">Respuesta rapida de lunes a viernes</div>
                </div>
              </a>
              <a href="mailto:sergiovrsa@gmail.com" className="ayuda-btn">
                <span className="ayuda-btn__icono">📧</span>
                <div>
                  <div className="ayuda-btn__titulo">Enviar un email</div>
                  <div className="ayuda-btn__sub">sergiovrsa@gmail.com</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}